import {
    GET_APPROVED_FINANCIAL_AID,
    GET_APPROVED_FINANCIAL_AID_SUCCESS,
    GET_APPROVED_FINANCIAL_AID_FAIL,

    FINANCIAL_AID_DETAILS,
    FINANCIAL_AID_DETAILS_SUCCESS,
    FINANCIAL_AID_DETAILS_FAIL,
    GET_FA_APT_DETAILS,
    GET_FA_APT_DETAILS_SUCCESS,
    GET_FA_APT_DETAILS_FAIL,
    GET_ALL_DONATIONS,
    DONATION_TOTAL,
    DONATION_TOTAL_FAIL,
    DONATION_TOTAL_SUCCESS,
    GET_ALL_DONATIONS_FAIL,
    GET_ALL_DONATIONS_SUCCESS,
  } from "./actionTypes";
  
  const INIT_STATE = {
    FAs: [],
    FA: {},
    donations: [],
    donationTotal: 0,
    FA_Apt:{}, //To save Appointment Details of the Financial Aid
    isLoading: false,
    error: null,
  };
  
  const AdminFAReducer = (state = INIT_STATE, action) => {
    switch (action.type) {

      case GET_APPROVED_FINANCIAL_AID:
        return {
          ...state,
          isLoading: true,
        };
      case GET_APPROVED_FINANCIAL_AID_SUCCESS:
        return {
          ...state,
          FAs: action.payload,
  
          isLoading: false,
        };
      case GET_APPROVED_FINANCIAL_AID_FAIL:
        return {
          ...state,
          error: action.payload,
        };
      case FINANCIAL_AID_DETAILS:
        return {
          ...state,
          isLoading: true,
        };
      case FINANCIAL_AID_DETAILS_SUCCESS:
        return {
          ...state,
          FA: action.payload,
          isLoading: false,
        };
      case FINANCIAL_AID_DETAILS_FAIL:
        return {
          ...state,
          error: action.payload,
        };
     
      case GET_FA_APT_DETAILS:
        return {
          ...state,
          isLoading: true,
        };
      case GET_FA_APT_DETAILS_SUCCESS:
        return {
          ...state,
          FA_Apt: action.payload,
          isLoading: false,
        };
      case GET_FA_APT_DETAILS_FAIL:
        return {
          ...state,
          error: action.payload,
        };
      case GET_ALL_DONATIONS:
        return {
          ...state,
          isLoading: true,
        };
      case GET_ALL_DONATIONS_SUCCESS:
        return {
          ...state,
          donations: action.payload,
          isLoading: false,
        };
       case GET_ALL_DONATIONS_FAIL:
        return {
            
          ...state,
          error: action.payload,
        };
        case DONATION_TOTAL:
        return {
          ...state,
          isLoading: true,
        };
      case DONATION_TOTAL_SUCCESS:
        return {
          ...state,
          donationTotal: action.payload,
          isLoading: false,
        };
      case DONATION_TOTAL_FAIL:
        return {
          ...state,
          error: action.payload,
        };
  
  
        
  
      default:
        return state;
    }
  };
  
  export default AdminFAReducer;
  